<template>
	<el-card shadow="never" class="aui-card--fill">
		<!-- <el-row style="background-color: #F3F4F4;">
			<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />
				{{!dataForm.id ? '新增合同' : '修改合同'}}
			</el-col>
			<el-col :xs="24" :md="18" style="text-align: right;">
				<el-button v-no-more-click type="primary" v-if="$hasPermission('plat:platcontract:save')" :loading="loadingbut" @click="dataFormSubmitHandle('1')">提交</el-button>
				<el-button v-no-more-click type="primary" v-if="$hasPermission('plat:platcontract:save')" :loading="loadingbut" style="background-color: skyblue" @click="dataFormSubmitHandle('0')">保存</el-button>
				<el-button @click="init()" v-if="dataForm.id">刷新</el-button>
				<el-button @click="$router.go(-1)">返回列表</el-button>
			</el-col>
		</el-row> -->
		<p v-if="caStatus == 7" style="color:red;margin-left:20px;">{{oldDataForm.reasonForRejection}}</p>
		<!-- <h2 class="titleH2" v-if="!$route.params.isContractList">三方合同</h2> -->
		<el-row style="background-color: #F3F4F4;" v-if="$route.params.isContractList">
			<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />
				合同详情
			</el-col>
			<el-col :xs="24" :md="18" style="text-align: right;">
				<el-button @click="handleNext()">返回</el-button>
			</el-col>
		</el-row>


		<el-row v-for="(item,index) in dataForm.contractArr" :key="item.bodyId">
		<h2 class="titleH2" v-if="false">{{`三方合同 - ${item.secondBody}`}}</h2>
		<el-form ref="dataForm" :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'">
		<!-- <el-form :model="dataForm" :rules="dataRule" ref="dataForm" :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'"> -->
			<el-row>
				<el-col :md="8" :lg="8">
					<el-form-item label="甲方" prop="firstId">
						<el-input v-model="item.firstBody" placeholder="甲方主体"  readonly disabled></el-input>
					</el-form-item>
				</el-col>
				<el-col :md="8" :lg="8">
					<el-form-item label="乙方" prop="secondBody">
						<el-input v-model="item.secondBody" placeholder="乙方主体"  readonly disabled></el-input>
					</el-form-item>
				</el-col>
				<el-col :md="8" :lg="8">
					<el-form-item label="丙方" prop="bodyOfPartyC">
						<el-input v-model="item.bodyOfPartyC" style="width: 95%;" placeholder="丙方联系人" disabled></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :md="8" :lg="8">
					<el-form-item label="甲方联系人" prop="firstUser">
						<el-input v-model="item.firstUser" style="width: 95%;" placeholder="甲方联系人" disabled></el-input>
					</el-form-item>
				</el-col>
				<el-col :md="8" :lg="8">
					<el-form-item label="乙方联系人" prop="secondUser">
						<el-input v-model="item.secondUser" style="width: 95%;" placeholder="乙方联系人" disabled></el-input>
					</el-form-item>
				</el-col>
				<el-col :md="8" :lg="8">
					<el-form-item label="丙方联系人" prop="contactOfPartyC">
						<el-input v-model="item.contactOfPartyC" style="width: 95%;" placeholder="丙方联系人" disabled></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :md="8" :lg="8">
					<el-form-item label="甲方联系地址" prop="firstAddress">
						<el-input v-model="item.firstAddress" style="width: 95%;" placeholder="甲方联系地址" disabled></el-input>
					</el-form-item>
				</el-col>
				<el-col :md="8" :lg="8">
					<el-form-item label="乙方联系地址" prop="secondAddress">
						<el-input v-model="item.secondAddress" style="width: 95%;" placeholder="乙方联系地址" disabled></el-input>
					</el-form-item>
				</el-col>
				<el-col :md="8" :lg="8">
					<el-form-item label="丙方联系地址" prop="addressOfPartyC">
						<el-input v-model="item.addressOfPartyC" style="width: 95%;" placeholder="丙方联系地址" disabled></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :md="8" :lg="8">
					<el-form-item label="开始日期" prop="startDate">
						<el-date-picker style="width: 95%;" :disabled="isDisabled" v-model="item.startDate" placeholder="开始日期" align="right" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"  :picker-options='pickerStartOptions(item.endDate)'></el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :md="8" :lg="8">
					<el-form-item label="结束日期" prop="endDate">
						<el-date-picker v-model="item.endDate" :disabled="isDisabled" style="width: 95%;" placeholder="结束日期" align="right" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options='pickerEndOptions(item.startDate)'></el-date-picker>
					</el-form-item>
				</el-col>
			</el-row>
			<el-form-item prop="platContractFileDTOList" label="合同附件" class="fileClass">
				<el-upload class="upload-demo" :action="url" :on-remove="(file,fileList) => handleRemove(file,fileList,'platContractFileDTOList',index)"  :before-remove="beforeRemove"
					:limit="1" accept=".pdf" :disabled="isDisabled"
					:on-error="backerror"
					:on-preview="handlePreview"
					:on-success="(res,file,fileList) => successHandle(res,file,fileList,'platContractFileDTOList',index)" :file-list="item.platContractFileDTOList ? item.platContractFileDTOList : []">
					<el-button size="small" type="primary" v-if="!item.platContractFileDTOList || item.platContractFileDTOList.length == 0">上传合同附件</el-button>
					<div slot="tip" class="el-upload__tip" v-if="!item.platContractFileDTOList || item.platContractFileDTOList.length == 0">上传三方合同,支持50M以内的pdf</div>
				</el-upload>
			</el-form-item>
			<!-- :on-preview="() => handlePreview()" -->
			<el-form-item prop="riskControlTables" label="风控表" class="fileClass">
				<el-upload class="upload-demo" :action="url" :on-remove="(file,fileList) => handleRemove(file,fileList,'riskControlTables',index)"  :before-remove="beforeRemove"
					:limit="1" :disabled="isDisabled"
					:on-error="backerror"
					:on-preview="handlePreview"
					:on-success="(res,file,fileList) => successHandle(res,file,fileList,'riskControlTables',index)" :file-list="item.riskControlTables ? item.riskControlTables : []">
					<el-button size="small" type="primary" v-if="!item.riskControlTables || item.riskControlTables.length == 0">上传风控表</el-button>
					<div slot="tip" class="el-upload__tip" v-if="!item.riskControlTables || item.riskControlTables.length == 0">上传盖企业公章的风控表,支持50M以内的excel</div>
					<!-- <span style="margin-left:20px;color:#188eee;" @click="handleDownFk()" v-if="!item.riskControlTables || item.riskControlTables.length == 0">下载模板</span> -->
				</el-upload>
			</el-form-item>
		</el-form>
	</el-row>


	<el-row style="border-top: 5px solid #F3F4F4;padding:0 20px;" v-if="$route.params.isContractList && dataForm.platContractProcessDTOList.length > 0">
		<div style="font-size: 14px;font-weight: bold;color: #333333;line-height: 40px;">合同状态</div>
		<div style="line-height: 25px;padding: 10px 0;font-size: 12px;">
			<p style="margin: 0;">
				合同编号<span style="margin-left: 40px;">{{dataForm.contractCode}}</span>
			</p>
		</div>
		<p style="margin: 0;line-height: 50px;border-bottom:1px solid #F3F4F4;"
			v-for="(value,key) in dataForm.platContractProcessDTOList">
			<!-- <span style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span> -->
			{{value.createDate}}
			<span style="margin-left: 40px;">{{value.username}}</span>
			<span style="margin-left: 40px;">{{value.operation}}</span>
			<span style="margin-left: 40px;">{{value.content}}</span>
		</p>
	</el-row>
</el-card>
</template>

<script>
import debounce from 'lodash/debounce'
import { addDynamicRoute } from "@/router";
import Cookies from 'js-cookie'
const _this = this;
export default {
	props:['parentId','caStatus','oldDataForm'],
	data () {
		return {
			pickerStartOptions(endTime){
                return {
                    disabledDate(time){
                        if(endTime){
                        // 拼接 00:00:00 是为了统一日期从0点开始 
                        return time.getTime() > new Date(endTime +' 00:00:00').getTime();
                        }
                    }
                } 
            },
            pickerEndOptions(startTime){
                return {
                    disabledDate(time){
                        if(startTime){
                        // 拼接 00:00:00 是为了统一日期从0点开始 
                        return time.getTime() < new Date(startTime +' 00:00:00').getTime();
                        }
                    }
                }
            },
			power:Cookies.get('admin_role'),
			dataForm: {
				parentUserId:'',
				startDate:'',
				endDate:'',
				platContractFileDTOList:[],
				platContractProcessDTOList:[],
				riskControlTable:''
			},
			url: `${window.SITE_CONFIG['apiURL']}/oss/file/upload2?access_token=${Cookies.get('access_token')}`,
			fileList: [],
			fileList1: [],
		}
	},
	computed: {
		dataRule () {
			return {
				startDate: [{required: true,message: this.$t('validate.required'),trigger: 'blur'}],
				endDate: [{required: true,message: this.$t('validate.required'),trigger: 'blur'}],
				platContractFileDTOList: [{required: true,message: this.$t('validate.required'),trigger: 'change'}],
				riskControlTable:[{required: true,message: this.$t('validate.required'),trigger: 'blur'}],
			}
		},
		isDisabled(){
			return (this.caStatus == 6 || this.caStatus == 8  || this.caStatus == 7 || this.caStatus == 9 || this.$route.params.isContractList) ?  true : false
		}
	},
	created(){
		this.init();
	},
	methods: {
		  //   返回上级
		handleNext(){
			console.log(this.$route.params.parentId)
			if(this.$route.params.parentId){//企业开票记录详情返回
				const routeParams = {
					routeName: 'plat-platticketrecordqy__任务详情',
					title: `申请开票`,
					path: 'plat/platinvoicingtasklist-add',
					params: {
						id:this.$route.params.parentId,
						isThreeRoute:true
					}
				}
				addDynamicRoute(routeParams, this.$router)
			}else{
				this.$router.back(this.num)
			}
		},
		// 封控表下载
		handleDownFk(){
			window.open(`${window.SITE_CONFIG['apiURL']}/sys/plat/info/ca/downloadRiskControllTable?userId=${this.dataForm.parentUserId}`)
		},
		backerror (e) {
			this.$message.error('文件上传失败，请重试')
		},
		init () {
			this.dataForm.parentUserId = this.$route.params.isContractList ? this.$route.params.id : this.parentId;
			console.log(this.dataForm.parentUserId)
			this.getInfo()
		},
		// 获取信息
		getInfo () {
			this.$http.get(`sys/plat/contract/getByUserId?userId=${this.dataForm.parentUserId}&bodyId=${this.$route.params.bodyId ? this.$route.params.bodyId : ''}`).then(({
				data: res
			}) => {
				// this.dataForm = {...this.dataForm,...res.data}
				// console.log(this.dataForm)
				// this.fileList = []
				// if(this.dataForm.platContractFileDTOList){
				// 	this.fileList.push({name:this.dataForm.platContractFileDTOList[0].fileName,url:this.dataForm.platContractFileDTOList[0].filePath})
				// }
				// this.fileList1 = []
				// if(this.dataForm.riskControlTable){
				// 	this.fileList1.push({name:'风控表.excel',url:this.dataForm.riskControlTable})
				// }
				// console.log(this.dataForm)
				// this.dataForm.platContractProcessDTOList = this.platContractProcessDTOList ? this.platContractProcessDTOList : []
				this.dataForm = {...this.dataForm,contractArr:res.data}
				if(res.data.length > 0 ){
					this.dataForm.contractArr.map((item,index) => {
						if(item.platContractFileDTOList && item.platContractFileDTOList.length > 0){
							item.platContractFileDTOList.map((list,listIndex) => {
								this.$set(this.dataForm.contractArr[index].platContractFileDTOList[listIndex],'name',list.fileName)
							})
						}
						if(item.riskControlTables && item.riskControlTables.length > 0){
							item.riskControlTables.map((list,listIndex) => {
								this.$set(this.dataForm.contractArr[index].riskControlTables[listIndex],'name',list.fileName)
							})
						}
					})
				}
			})
		},
		// 限制附件文件类型和大小
		beforeUploadHandle (file) {
			if (file.type != 'application/pdf') {
				this.$message.error(this.$t('upload.tip', {
				'format': 'pdf'
				}))
				return false
			}
			if (file.size / 1024 / 1024 > 50) {
				this.$message.error('文件太大，只能上传50MB以内的pdf文件')
				return false
			}
		},
		beforeUploadHandle1 (file) {
			var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
			if (testmsg != 'xls' && testmsg != 'xlsx') {
				this.$message.error(this.$t('upload.tip', {
				'format': 'excel'
				}))
				return false
			}
			if (file.size / 1024 / 1024 > 50) {
				this.$message.error('文件太大，只能上传50MB以内的excel文件')
				return false
			}
		},
		// 附件删除
		handleRemove (file, fileList) {
			for (let i = 0; i < fileList.length; i++) {
				fileList[i].name = fileList[i].response.data.fileName + '.' + fileList[i].response.data.fileType
			}
			this.fileList = fileList
			this.dataForm.platContractFileDTOList = fileList
		},
		handleRemove1 (file, fileList) {
			for (let i = 0; i < fileList.length; i++) {
				fileList[i].name = fileList[i].response.data.fileName + '.' + fileList[i].response.data.fileType
			}
			this.fileList1 = []
			this.dataForm.riskControlTable = ''
		},
		beforeRemove(file,fileList){
			if(file.status == 'success') return this.$confirm(`确定移除 ${ file.name }？`);
		},
		// 上传成功
		successHandle (res, file, fileList) {
			if (res.code !== 0) {
				return this.$message.error(res.msg)
			}
			for (let i = 0; i < fileList.length; i++) {
				fileList[i].name = fileList[i].response.data.fileName + '.' + fileList[i].response.data.fileType
			}
			this.fileList = fileList
			this.dataForm.platContractFileDTOList = [{fileName:res.data.fileName, filePath:res.data.url,fileType:'pdf'}]
			console.log(this.dataForm)
			this.$refs["dataForm"].validateField('platContractFileDTOList');
		},
		successHandle1 (res, file, fileList) {
			if (res.code !== 0) {
				return this.$message.error(res.msg)
			}
			for (let i = 0; i < fileList.length; i++) {
				fileList[i].name = fileList[i].response.data.fileName + '.' + fileList[i].response.data.fileType
			}
			this.fileList1 = fileList
			this.dataForm.riskControlTable = res.data.url
			console.log(this.dataForm)
			this.$refs["dataForm"].validateField('riskControlTable');
		},
		// 预览附件 
		handlePreview (file) {
			console.log(file)
			window.open(file.filePath)
			// window.open(this.dataForm.platContractFileDTOList[0].filePath)
		},
		// 预览附件 
		handlePreview1 () {
			window.open(this.dataForm.riskControlTable)
		},
		// 表单提交
		dataFormSubmitHandle: debounce(function (inStatus) {
			this.dataForm.status = inStatus
			if(inStatus == 0){
				let url = this.dataForm.id ? '/sys/plat/contract/updateByAgent' : '/sys/plat/contract/saveByAgent'
				console.log(this.dataForm)
				this.$http.post(url, this.dataForm).then(({ data: res }) => {
					if (res.code !== 0) {
						return this.$message.error(res.msg)
					}
					this.$message({
						message: (inStatus == 1 ? '提交成功' : '保存成功'),
						type: 'success',
						duration: 500,
						onClose: () => {
							this.$router.back(-1)
						}
					})
				}).catch(() => {})
				return false;
			}
			console.log(this.dataForm)
			this.$refs['dataForm'].validate(valid => {
				if (!valid) {
					return false
				}
				if (this.fileList.length == 0) {
					return this.$message.error('请上传附件')
				}
				// this.sunmitFomr();
				let url = this.dataForm.id ? '/sys/plat/contract/updateByAgent' : '/sys/plat/contract/saveByAgent'
				console.log(this.dataForm)
				this.$http.post(url, this.dataForm).then(({ data: res }) => {
					if (res.code !== 0) {
						return this.$message.error(res.msg)
					}
					this.$message({
						message: (inStatus == 1 ? '提交成功' : '保存成功'),
						type: 'success',
						duration: 500,
						onClose: () => {
							this.$router.back(-1)
						}
					})
				}).catch(() => {})
			})},1000, {
				leading: true,
				trailing: false
			}),
		},
		aaa(){
			console.log(213213)
		},
		handleSubmit(){
			let url = this.dataForm.id ? '/sys/plat/contract/updateByAgent' : '/sys/plat/contract/saveByAgent'
			console.log(this.dataForm)
			this.$http.post(url, this.dataForm).then(({ data: res }) => {
				if (res.code !== 0) {
					return this.$message.error(res.msg)
				}
				this.$message({
					message: (inStatus == 1 ? '提交成功' : '保存成功'),
					type: 'success',
					duration: 500,
					onClose: () => {
						this.$router.back(-1)
					}
				})
			}).catch(() => {})
		}
	}
</script>
<style lang="scss">
.fileClass{
	.el-form-item__content{
		line-height: 0 !important;
	}
	.el-upload__tip{
		margin-top:12px;
	}
}

.titleH2{
	font-size: 16px;
	border-left: 5px solid #188eee;
	padding-left: 5px;
	color:#333;
	font-weight:bold;
	margin:20px;
}
	
</style>